import * as TableDataTab from './TableDataTab.svelte';
import * as CollectionDataTab from './CollectionDataTab.svelte';
import * as ViewDataTab from './ViewDataTab.svelte';
import * as TableStructureTab from './TableStructureTab.svelte';
import * as QueryTab from './QueryTab.svelte';
import * as ShellTab from './ShellTab.svelte';
import * as ArchiveFileTab from './ArchiveFileTab.svelte';
import * as PluginTab from './PluginTab.svelte';
import * as MarkdownEditorTab from './MarkdownEditorTab.svelte';
import * as MarkdownViewTab from './MarkdownViewTab.svelte';
import * as MarkdownPreviewTab from './MarkdownPreviewTab.svelte';
import * as FavoriteEditorTab from './FavoriteEditorTab.svelte';
import * as CommandListTab from './CommandListTab.svelte';
import * as YamlEditorTab from './YamlEditorTab.svelte';
import * as JsonEditorTab from './JsonEditorTab.svelte';
import * as JsonLinesEditorTab from './JsonLinesEditorTab.svelte';
import * as JsonTab from './JsonTab.svelte';
import * as ChangelogTab from './ChangelogTab.svelte';
import * as DiagramTab from './DiagramTab.svelte';
import * as DbKeyDetailTab from './DbKeyDetailTab.svelte';
import * as QueryDataTab from './QueryDataTab.svelte';
import * as ConnectionTab from './ConnectionTab.svelte';
import * as MapTab from './MapTab.svelte';
import * as ServerSummaryTab from './ServerSummaryTab.svelte';
import * as ImportExportTab from './ImportExportTab.svelte';
import * as SqlObjectTab from './SqlObjectTab.svelte';
import * as AppLogTab from './AppLogTab.svelte';

import protabs from './index-pro';

export default {
  TableDataTab,
  CollectionDataTab,
  ViewDataTab,
  TableStructureTab,
  QueryTab,
  ShellTab,
  ArchiveFileTab,
  PluginTab,
  MarkdownEditorTab,
  MarkdownViewTab,
  MarkdownPreviewTab,
  FavoriteEditorTab,
  CommandListTab,
  YamlEditorTab,
  JsonEditorTab,
  JsonLinesEditorTab,
  JsonTab,
  ChangelogTab,
  DiagramTab,
  DbKeyDetailTab,
  QueryDataTab,
  ConnectionTab,
  MapTab,
  ServerSummaryTab,
  ImportExportTab,
  SqlObjectTab,
  AppLogTab,
  ...protabs,
};
